import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { Controller } from "react-hook-form"
import { withTranslation } from 'react-i18next'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import Input from 'react-phone-number-input/input'
import ReactCountryFlag from "react-country-flag"


export default withTranslation()(function PhoneNumberInput(props) {
  const { name, label, className: { inputClass, bodyClass }, singleInputClassName, passedValue = 0, country = false, errorState = (data) => data, disabled = false, labelWithin = false, code } = props
  // const Flag = Flags['us'];
  const { control, watch, trigger } = useFormContext()
  let v = watch(name)

  useEffect(() => {
    if (v) trigger(name)
  }, [v, trigger, name])

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
        <div className="text-left">
          {!labelWithin ? <label htmlFor={name} className="text-secondary text-sm inline-block mb-3">{label}</label> : null}
          {country ?
            <>
              <div className='flex items-center gap-[8px] w-full px-2 rounded-lg bg-input'>
                <div className='flex gap-[8px] items-center'>
                  <div> <ReactCountryFlag countryCode={country} svg style={{
                    width: '34px',
                    height: '30px',
                  }} /></div>
                  <div style={{ fontSize: '14px' }}>+{code}</div>
                </div>

                <Input
                  defaultCountry='NG'
                  country={country}
                  className={singleInputClassName}
                  onChange={
                    (val) => { onChange(val); errorState(watch(name) ? isValidPhoneNumber(watch(name)) : false) }
                  }
                  onBlur={
                    onBlur
                  }
                  value={value ? value?.countryCallingCode : passedValue}
                  error={value ? (isValidPhoneNumber(value) ? undefined : 'Invalid phone number') : 'Phone number required'}

                />
              </div>
              <span className={'text-danger'}>  {watch(name) ? (isValidPhoneNumber(watch(name)) ? undefined : `invalid phone number for selected country (${country})`) : ' '}</span>
            </>
            :
            <PhoneInput
              defaultCountry="NG"
              numberInputProps={{
                className:` ${inputClass || 'py-4 rounded-r-lg !bg-input'} `
              }}
              className={bodyClass || 'bg-input w-full rounded-lg pl-2'}
              onChange={
                (val) => { onChange(val); errorState(watch(name) ? isValidPhoneNumber(watch(name)) : false) }
              }
              onBlur={
                onBlur
              }
              value={value ? value : passedValue}
              disabled={disabled}
            />
          }



        </div>
      )}
    />
  )
})